<template>
    <div class="flex flex-column">
        <span class="font-semibold">{{ label }}</span>
        <small class="text-color-secondary" v-if="nif">{{ nif }}</small>
    </div>
</template>

<script setup lang="ts">
defineProps<{
    label: string
    nif?: string
}>()
</script>
